/**
 * Register the PWA service worker (production only).
 *
 * We deliberately keep this simple — no Workbox dependency. The SW lives at
 * /service-worker.js with `scope: '/'` so it covers the marketing site, the
 * customer app and the admin dashboard. In dev (CRA) we *unregister* any
 * stale SW left over from previous installs to avoid stale-cache bugs.
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  if (process.env.NODE_ENV !== 'production') {
    // Dev cleanup — a previously installed prod SW would otherwise serve
    // cached assets on localhost and confuse hot-reload.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    }).catch(() => {});
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .catch((err) => {
        // Non-fatal — the app still works without the SW.
        // eslint-disable-next-line no-console
        console.warn('SW registration failed', err);
      });
  });
}
